import * as React from "react";
const SvgSafe = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1.25A1.75 1.75 0 0 0 1.25 3v2.25H1A.75.75 0 0 0 .25 6v3c0 .414.336.75.75.75h.25v2.5H1a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h.25V19c0 .966.784 1.75 1.75 1.75h.25V22a.75.75 0 0 0 1.5 0v-1.25h16.5V22a.75.75 0 0 0 1.5 0v-1.418c.591-.281 1-.884 1-1.582V3A1.75 1.75 0 0 0 22 1.25H3ZM2.75 16v3c0 .138.112.25.25.25h19a.25.25 0 0 0 .25-.25V3a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v13ZM17 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-4 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM7.232 9.336a2.25 2.25 0 1 1 3.182 3.182 2.25 2.25 0 0 1-3.182-3.182Zm5.657-1.414-.937.937c.78 1.178.825 2.7.135 3.917l.802.802a.75.75 0 0 1-1.06 1.061l-.731-.73a3.753 3.753 0 0 1-4.343.147l-.583.583a.75.75 0 1 1-1.061-1.06l.583-.584a3.753 3.753 0 0 1 .147-4.343l-.73-.73A.75.75 0 0 1 6.17 6.86l.803.802a3.756 3.756 0 0 1 3.918.135l.937-.937a.75.75 0 1 1 1.06 1.06Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSafe;
